import * as Sentry from '@sentry/browser';
import { initLoc as initLocalization, t } from '../../../packages/src/localization/index.js';
import { getEventLanguageSettings, normalizeLanguageSettings } from '../../../packages/src/localization/languageSettings.js';

export { t };

const LOC_PARAMS_KEY = 'locParams';

export async function initLoc(params = getLocParams()) {
  const locParams = {
    ...getLocParams(),
    ...(params || {}),
  };
  const languageSettings = normalizeLanguageSettings(locParams.languageSettings);
  const initialLanguage = resolveInitialLanguage(languageSettings);

  if (locParams.orgId || locParams.eventCode) {
    setLocParams({
      ...locParams,
      languageSettings,
    });
  }

  if (!locParams.orgId || !locParams.eventCode) {
    const error = new Error('Organisation ID and Event Code are required for localisation initialization.');
    Sentry.captureException(error);
  }

  await initLocalization({
    orgId: locParams.orgId,
    eventCode: locParams.eventCode,
    projectName: 'webapp',
    languageSettings,
    initialLanguage,
  });
}

export async function initEventLoc(event) {
  await initLoc(createEventLocParams(event));
}

export function storeEventLocContext(event) {
  setLocParams(createEventLocParams(event));
}

export function getCurrentLanguageSettings() {
  return normalizeLanguageSettings(getLocParams().languageSettings);
}

export function setTextToElement(cssPath, text) {
  const element = document.querySelector(cssPath);
  if (element) {
    element.textContent = text;
  } else {
    const error = new Error(`Element not found for CSS path: ${cssPath}`);
    console.error(error);
    Sentry.captureException(error);
  }
}

function createEventLocParams(event) {
  return {
    orgId: event.organisation?.id,
    eventCode: event.name,
    languageSettings: getEventLanguageSettings(event.opts),
  };
}

function setLocParams(locParams = {}) {
  sessionStorage.setItem(LOC_PARAMS_KEY, JSON.stringify(locParams || {}));
}

function getLocParams() {
  return JSON.parse(sessionStorage.getItem(LOC_PARAMS_KEY) || '{}');
}

function resolveInitialLanguage(languageSettings) {
  const allowedLanguages = new Set(languageSettings.availableLanguages);
  const storedLanguage = localStorage.getItem('i18nextLng');

  if (allowedLanguages.has(storedLanguage)) {
    return storedLanguage;
  }

  const browserLanguage = window.navigator.language.split('-')[0];
  if (allowedLanguages.has(browserLanguage)) {
    return browserLanguage;
  }

  return languageSettings.defaultLanguage;
}
